export default __webpack_public_path__ + "static/agc2-90d258ec263bc1750d4b9ab29105c0c6.png";